module.exports = require("./fr-NC");